import { render, staticRenderFns } from "./realEstateAdmin.vue?vue&type=template&id=3dcc27d6&"
import script from "./realEstateAdmin.vue?vue&type=script&lang=js&"
export * from "./realEstateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./realEstateAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports